<app-card [title]="'person.contactInfo.label'" titleSize="large">
    <ng-template #content>
        @if (form()) {
            <div class="input-grid-gaps grid-2col p-1">
                <app-phone-input
                    id="phone"
                    [disabled]="!canEdit()"
                    [form]="form()"
                ></app-phone-input>
                <app-phone-input
                    id="mobile"
                    label="inputs.mobile"
                    icon="pi-mobile"
                    [disabled]="!canEdit()"
                    [form]="form()"
                ></app-phone-input>
                <app-password-input
                    id="communikePassword"
                    label="inputs.communikePassword"
                    [disabled]="!canEdit()"
                    [form]="form()"
                ></app-password-input>
                <app-email-input
                    id="email"
                    label="inputs.email"
                    [disabled]="!canEdit()"
                    [form]="form()"
                ></app-email-input>
            </div>
        }
    </ng-template>
</app-card>
